<!-- eslint-disable vue/no-v-html -->
<template>
  <router-link v-if="dataCard" :to="'/' + getSourceLabel(dataCard.source) + '/' + dataCard.id" class="search-card-link">
    <div class="search-card">
      <div class="search-card-icon">
        <ItemIcon :type="dataCard.source" :size="isMobile ? 'xsm' : 'sm'" :filled="false" />
        <div v-if="isMobile && dataCard.showDate" class="date-wrapper">
          <div class="card-date">{{ $t('dates_from') }} {{ formattedShowDate }}</div>
        </div>
      </div>
      <div class="search-card-info">
        <div class="search-card-info-title">{{ dataCard.title }}</div>
        <div v-if="dataCard.description && type === 'normal'" class="search-card-info-description">{{ noMarkdownDesc }}</div>
        <div class="search-card-info-more">
          <div class="card-other-info">
            <div v-if="dataCard.publishDate" class="card-desc">
              <div class="icon-calendar" />
              {{ formattedPublishDate }}
            </div>
            <div v-if="dataCard.docSource !== ''" class="card-desc card-origin">
              <span class="origin-text" v-html="$t('add_font') + ': ' + dataCard.docSource.join(', ')" />
            </div>
            <div v-if="dataCard.showDate && type === 'fav-list'" class="card-desc">
              {{ $t('dates_from') + formattedShowDate }}
            </div>
          </div>
          <div class="more-info-wrap">
            <div v-if="!isMobile && dataCard.showDate && type === 'normal'" class="date-wrapper">
              <div class="card-date">{{ $t('dates_from') + formattedShowDate }}</div>
            </div>
            <ItemTimeIcon v-if="dataCard.frequency" :types="dataCard.frequency" />
            <ItemLocaIcon v-if="dataCard.territories" :types="dataCard.territories" />
          </div>
        </div>
      </div>
      <div v-if="type === 'fav-list'" class="noti-wrap">
        <NotifPro :fav-id="dataCard.favouriteId" :enabled-state="dataCard.enabled" @reload-data="reloadData" />
      </div>
    </div>
  </router-link>
</template>

<script>
import dayjs from 'dayjs'
import NotifPro from '../profile/NotifPro.vue'
import ItemIcon from '../ItemIcon.vue'
import ItemTimeIcon from '../ItemTimeIcon.vue'
import ItemLocaIcon from '../ItemLocaIcon.vue'
const removeMd = require('remove-markdown');

/**
 * View of result card of search
 * @example [none]
 */
export default {
  name: 'SearchCard',
  components: {
    NotifPro,
    ItemIcon,
    ItemTimeIcon,
    ItemLocaIcon,
  },
  props: {
    /**
     * Contains the data card object information returned by the api
     */
    dataCard: {
      type: Object,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {
    noMarkdownDesc(){
      return removeMd(this.dataCard.description)
    },
    currentLang() {
      return this.$store.state.i18n.lang
    },
    formattedShowDate() {
      //anual, month, day, trimestral...
      let showDate = this.dataCard.showDate.replace('Z', '')
      if (this.dataCard.typeTime /*&& this.dataCard.typeTime.ca*/ === 'mes')
        return dayjs(showDate).format('MMM YYYY')
      else return dayjs(showDate).format('YYYY')
    },
    formattedPublishDate() {
      return dayjs(this.dataCard.publishDate.replace('Z', '')).format('DD/MM/YYYY')
    },
  },
  methods: {
    getSourceLabel(source) {
      let type = this.$getTypesOfContent.data.find(el => el.type === source)
      return type ? type.label[this.currentLang] : null
    },
    reloadData() {
      this.$emit('rereload')
    },
  },
}
</script>

<style lang="stylus" scoped>
.search-card-link:hover
  text-decoration: none
.search-card
  display: flex
  padding: vw(20px) vw(30px)
  border: 1px solid $bcn-very-light-grey
  border-radius: 4px
  background-color: #fff
  box-shadow: 0 0 10px rgba(105, 105, 115, 0.05)
  cursor: pointer
  gap: vw(20px)

  &:hover
    border: 1px solid $corporate_color

  .mobile &
    display: block
    padding: vw(20px)

.search-card-icon
  .mobile &
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: vw(15px)

.more-info-wrap
  display: flex
  align-items: center

.date-wrapper
  padding: vw(4px) vw(12px)
  padding-top: vw(5px)
  border: 1px solid $corporate_color_light
  border-radius: 20px

  .card-date
    m-font-size(12, 16)
    color: $grey

    .mobile &
      m-font-size(14, 20)

.search-card-info
  flex: 1 1 0%

.noti-wrap
  display: flex

.search-card-info-title
  m-font-size(18, 26)
  margin-bottom: vw(5px)
  color: #000
  font-weight: 600

.search-card-info-description
  m-font-size(14, 22)
  margin-bottom: vw(15px)
  color: $grey
  font-weight: 300
  display: -webkit-box
  -webkit-line-clamp: 3
  -webkit-box-orient: vertical
  overflow: hidden

.search-card-info-more
  display: flex
  align-items: center
  gap: vw(20px)

.card-other-info
  display: flex
  flex: 1 1 0%
  align-items: flex-start

.origin-text
  display: -webkit-box
  -webkit-line-clamp: 2
  -webkit-box-orient: vertical
  overflow: hidden

.card-desc
  m-font-size(12, 16)
  display: flex
  align-items: center
  color: $grey

  .mobile &
    m-font-size(14, 20)

  &:not(:last-child)
    margin-right: vw(10px)
    padding-right: vw(10px)
    border-right: 1px solid $bcn-other-grey

  .icon-calendar
    m-icon("calendar", 16)
    margin-top: -0.15em
    margin-right: vw(5px)

.card-more
  m-font-size(15, 19)
  color: $corporate_color
  font-weight: 400
</style>
